import api from './api';
import type { DriverStatusBoardParams, DriverStatusBoardResponse } from '../types/driverStatusBoard';

/**
 * Fetch one day of the Driver Status Board.
 *
 * Absent/blank params are omitted rather than sent as empty strings — the
 * endpoint's own defaults (ALL dispatchers, today) are the intended behavior,
 * and a blank `date` would fail its YYYY-MM-DD parse.
 */
export const getDriverStatusBoard = async (
  params: DriverStatusBoardParams = {},
  signal?: AbortSignal,
): Promise<DriverStatusBoardResponse> => {
  const query: Record<string, string> = {};
  if (params.date) query.date = params.date;
  const dispatchers = (params.dispatchers || []).map((d) => d.trim()).filter(Boolean);
  if (dispatchers.length) query.dispatchers = dispatchers.join(',');
  if (params.hide_completed) query.hide_completed = 'true';

  if (params.additional_fields?.length) query.additional_fields = params.additional_fields.join(',');

  const response = await api.get<DriverStatusBoardResponse>('/dispatching/driver-status-board', {
    params: query,
    signal,
  });
  return response.data;
};

const driverStatusBoardService = { getDriverStatusBoard };

export default driverStatusBoardService;
